import React from 'react';
import { useTranslation } from 'react-i18next';
import TypingIndicator from './TypingIndicator';

  
const TestbotPanel = ({
  isPanelOpen,
  togglePanel,
  closeIcon,
  testingMsgList,
  testingMsgListRef,
  testingMessage,
  setTestingMessage,
  handleKeyPress,
  handleSendTestingMsg,
}) => {

 const { t } = useTranslation();

  return (
    <div className={`testbot-panel ${isPanelOpen ? 'testbot-panel--open' : 'testbot-panel--closed'}`}>
      <div className="testbot-panel-header">
        <div className="testbot-panel-content">
          <h2 className="testbot-panel-title">{t('botTrainingPage.botPreviewTitle')}</h2>
          <button onClick={togglePanel} className="testbot-panel-close-button">
            <img src={closeIcon} alt="close" />
          </button>
        </div>
      </div>

      <div className="fixed-container" style={{ margin: '40px' }}>
        <div className="chat-box" style={{ border: '1px solid #7F28F8' }}>
          <div className="header_chat" style={{ background: '#7F28F8' }}>
            <img
              src="https://www.shutterstock.com/image-vector/chat-bot-logo-design-concept-600nw-1938811039.jpg"
              alt="Logo"
            />
          </div>

          <div className="messages-container" ref={testingMsgListRef}>
            {testingMsgList.map((msg, index) =>
                msg.isTyping ? (
                    <TypingIndicator/>
                ) : (
                <div
                    key={index}
                    className={`message ${msg.from_bot ? 'business-message' : 'user-message'}`}
                    style={{ background: msg.from_bot ? '#eee' : '#7F28F8' }}
                >
                    <p style={{ color: msg.from_bot ? '#000' : '#fff' }}>
                    {msg.message}
                    </p>
                </div>
                )
            )}
            </div>


          <div className="input-container">
            <input
              type="text"
              placeholder={t('botTrainingPage.inputPlaceholder')}
              style={{ border: '1px solid #7F28F8' }}
              value={testingMessage}
              onChange={(e) => setTestingMessage(e.target.value)}
              onKeyPress={handleKeyPress}
            />
            <button type="button" onClick={handleSendTestingMsg}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M19.5656 12.5913C19.4092 12.9268 19.1426 13.1929 18.8233 13.3529L6.75036 19.4461C5.89387 19.8649 4.86032 19.5233 4.42563 18.6844C4.2343 18.2793 4.19549 17.822 4.32795 17.3955L5.64831 13.0972C5.7692 12.7037 6.13274 12.435 6.54448 12.435H11.1654C11.505 12.4337 11.7828 12.1592 11.7905 11.8101C11.7884 11.4663 11.514 11.1885 11.1654 11.1851H6.54788C6.13452 11.1851 5.76995 10.9144 5.65042 10.5187L4.34749 6.20514C4.07489 5.3055 4.58948 4.34594 5.50008 4.07643C5.92157 3.94393 6.37753 3.98415 6.76989 4.19362L18.8233 10.2868C19.6653 10.7168 20.0041 11.7517 19.5656 12.5913Z"
                  fill="#7F28F8"
                />
              </svg>
            </button>
          </div>

          <div className="flex items-center justify-center">
            <a href="https://jaweb.me/" target="_blank" rel="noopener noreferrer">
              <span className="text-gray-500">{t('botTrainingPage.poweredBy')}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestbotPanel;
